import type { Detections } from "@/features/presets/preset"
import { getCameraPermissionStore } from "@/stores/camera-permission"
import { onDestroy } from "svelte"

/**
 * Reusable logic for tracking camera permissions.
 * There is an issue with mobile Safari where the permission's onchange event doesn't work and the only way to track the camera permission state is by manually updating it.
 * This function uses face detections change as a trigger to check the camera permission state and starts polling it.
 * null face detection is just a reason to check the camera permission state, as one of the reasons of the face detection absence is the lack of camera permissions.
 *
 * For more details, see comment in the camera permission store
 */
export const create = () => {
  const cameraPermission = getCameraPermissionStore()

  let interval: ReturnType<typeof setInterval> | null = null

  const checkPermission = () => {
    if (interval) return
    cameraPermission.refresh()
    interval = setInterval(() => cameraPermission.refresh(), 1500)
  }
  const clear = () => {
    if (!interval) return
    clearInterval(interval)
    interval = null
  }

  onDestroy(clear)

  return {
    update({ detections }: { detections: Detections | null }) {
      if (!detections?.face) checkPermission()
      else clear()
    },
  }
}
